import { createContext } from "react"
import { IFieldContext } from "../../../interface/FormGenerator"

// @ts-ignore
const FieldContext = createContext<IFieldContext>({})

export default FieldContext
